   <template>
   <div>
<NavHeader/>



<div class="main-header-content">
	<div class="container">
		<h3>Contact Us</h3>
	</div>
</div>

<div class="divider"></div>

<div class="contact-us-content">
	<div class="container">
		<p class="content-para text-center"><a href="tel:+60383138606">Call Us!</a> Customer Care Hotlines operates from 9am to 6pm daily including public holidays.<br>Our team of Customer Care Consultants will be pleased to assist you.</p>
	</div>
</div>

<div class="divider"></div>


<div class="contact-detail">
	<div class="left-detail">
		<div class="main-contact-detail">
			<img class="person-img" src="/static/commercial/img/icons/person.png" alt="">
			<h3>eRemit Personal</h3>
			<ul>
				<li><img src="/static/commercial/img/icons/call.png" alt=""><a href="tel:+60383138606">Tel +603-8313 8606 & +603-7724 2070</a></li>
				<li><img src="/static/commercial/img/icons/fax.png" alt="">Fax +6 03 7724 1811</li>
				<li><img src="/static/commercial/img/icons/mail.png" alt=""><a href="mailto:customercare@eremit.com.my" target="_top">customercare@eremit.com.my</a></li>
			</ul>
		</div>
	</div>
	<div class="right-detail">
		<div class="main-contact-detail">
			<img class="person-img" src="/static/commercial/img/icons/person.png" alt="">
			<h3>eRemit Business</h3>
			<ul>
				<li><img src="/static/commercial/img/icons/call.png" alt=""><a href="tel:+60383138606">Tel +603-8313 8606 & +603-7724 2070 & +6013-368 8606</a></li>
				<li><img src="/static/commercial/img/icons/fax.png" alt="">Fax +6 03 7724 1811</li>
				<li><img src="/static/commercial/img/icons/mail.png" alt=""><a href="mailto:bizcare@eremit.com.my" target="_top">bizcare@eremit.com.my</a></li>
			</ul>
		</div>
	</div>
</div>


<div class="divider"></div>

<div class="other-contact-detail">
	<div class="container">
		<div class="row">
			<div class="col-md-6">
				<div class="left-other-detail">
					<h4>Mailing Address</h4>
					<p>Merchantrade Asia Sdn Bhd</p>
					<p>Suite 712, Level 7, Lobby 3 Block A, Damansara Intan, No 1, Jalan SS20/27, 47400 Petaling Jaya, Selangor Darul Ehsan, Malaysia.</p>
				</div>
			</div>
			<div class="col-md-6 bdl">
				<div class="right-other-detail">
					<h4>Merchantrade Branches</h4>
					<p>Document submission & verification can only be done at Merchantrade branches.</p>
					<div class="find-location">
						<a href="https://mtradeasia.com/main/locate-us/" class="main-btn">Find Locations <i class="fas fa-angle-right"></i></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="divider"></div>












</div>
    </template>
    <script>

import DownloadApp from "../../shared/commercial/DownloadApp.vue";
import NavHeader from "../../shared/commercial/NavHeader.vue";
import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";



export default {
  name: "Dashboard",
  
  components : {DownloadApp,NavHeader,SignUpFooter},


  created() {},
  data() {
    return {
      ExchangeRateCollection: [],
      RecentTransactionCollection: [],
      NotificationCollection: [],
		
      RecipientCollection: null,
			ClassBadge : { 'badge-yellow' : true },
      itemTemplate:
        '<div class="m-b-sm m-t-sm">#:data.Fullname# <br/><img style="width:24px;" src="static/img/flags/#:data.FlagCode#.png" />#:data.CountyName#<br/> #:data.PayoutMode#</div>',
      vModel: {
        RecipientId: null
      }
    };
  },
  methods: {

		badgeColor : function(statusid){

		var color = { 'badge-yellow' : true}

		switch(statusid){
      case 1 :
      case 2 :
      case 3 :
      case 4 :
      case 6 :
      case 7 :
      case 8 :
      case 14 :
      case 15 :
      color = { 'badge-yellow' : true}
      break;
      case 5 :
      color  ={ 'badge-green' : true}
      break;
      case 9 :
      case 11 :
      case 12 :
      case 19 : 
      case 20:
      case 21 :
      color  ={ 'badge-red' : true}
      break;

      case 10 :
      case 13 :
      color  ={ 'badge-grey' : true}
      break;
		}

		return color;

		},
    sendMoney: function(e) {
      window.Vue.$router.push(e.sender._old);
    },
		pullpromotion: function(){

		}
  }
};
</script>

